// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"31b95e19","239":"f21e5f3d","732":"8d020c14"}[chunkId] + ".chunk.js";
};